import { render, staticRenderFns } from "./GalleryIcon.vue?vue&type=template&id=380a6538"
import script from "./GalleryIcon.vue?vue&type=script&lang=js"
export * from "./GalleryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports